module.exports = __webpack_public_path__ + "c77ce2771905e2c687fcbc1ede16c6f5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/af.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/af.svg
// module chunks = 0